import axios from 'axios';
import { API } from '../api';
import i18n from '../i18n';

/* Cliente de los 3 endpoints del alta CLUB (contrato Guardián 2026-07-11, firme):
   - iniciar   POST /canal/registro/iniciar {email}                → 200 genérico (anti-enumeración)
   - verificar GET  /canal/registro/verificar?token=              → {ok} | {code:TOKEN_CADUCADO|TOKEN_INVALIDO}
   - completar POST /canal/registro/completar {token,password,...} → 200 {ok,next:"pago"}
   Errores (code en detail): EMAIL_INVALIDO, PASSWORD_DEBIL, CONSENTIMIENTO_REQUERIDO, RATE_LIMIT, BOT_DETECTADO. */

// Ann 2026-09-10: «todo en el idioma seleccionado por el cliente». El alta empieza en el idioma
// de la web (i18n) y ese idioma acompaña a la clienta: correo de verificación, cuenta creada con
// idioma_preferido y todos sus correos posteriores.
export const registroIniciar = (email, aceptaComunicaciones = false) => axios.post(`${API}/canal/registro/iniciar`, { email, acepta_comunicaciones: aceptaComunicaciones, idioma: (i18n.language || 'es').slice(0, 2) });
export const registroVerificar = (token) => axios.get(`${API}/canal/registro/verificar`, { params: { token } });
export const registroCompletar = (payload) => axios.post(`${API}/canal/registro/completar`, payload);
// Cierre del circuito (Ann 2026-07-18): la página «Pago recibido» confirma el
// pago preguntando a la plataforma (requiere sesión). {acceso:bool, ya_activo}.
export const confirmarPago = () => axios.post(`${API}/canal/registro/confirmar-pago`);

// Extrae el code del error (soporta {detail:{code}} o {code}) y su HTTP.
export function errorCode(err) {
  const d = err?.response?.data;
  return d?.detail?.code || d?.code || (err?.response?.status === 429 ? 'RATE_LIMIT' : '');
}

// Mensaje de usuario según el code del contrato (anti-enumeración: nunca "email ya registrado").
// Bilingüe ES/CA (F4): los textos viven en i18n/locales/{es,ca}/auth.json → erroresApi.*
export function mensajeError(err) {
  const code = errorCode(err);
  const clave = `auth:erroresApi.${code}`;
  if (code && i18n.exists(clave)) return i18n.t(clave);
  return i18n.t('auth:erroresApi.generico');
}
